import FeedSourceRequestsList from "./List";
import FeedSourceRequestsEdit from "./Edit";
export default [
    { exact: true, path: "/feeds-requests", component: FeedSourceRequestsList },
    { path: "/feeds-requests/c", component: FeedSourceRequestsEdit },
    { path: "/feeds-requests/e/:_id", component: FeedSourceRequestsEdit }
];
